import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.jsx'
import { NotificationsProvider } from './context/NotificationsContext.jsx'
import { SocketProvider } from './context/SocketContext.jsx'
import * as Sentry from "@sentry/react";
import axios from 'axios';

// Axios defaults for HTTP-only cookies
axios.defaults.withCredentials = true;

// ✅ Request Interceptor: Attach token for mobile / cross-site / PWA reliability
axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('ff_arena_token');
    if (token && !config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Register unified service worker for PWA and Notifications
if ("serviceWorker" in navigator) {
  window.addEventListener('load', () => {
    // Register the main PWA service worker (which imports firebase-messaging-sw.js)
    navigator.serviceWorker.register("/sw.js")
      .then((registration) => {
        console.log("✅ PWA Service Worker registered:", registration.scope);
      })
      .catch((error) => {
        console.error("❌ SW registration failed:", error);
      });
  });
}

import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      cacheTime: 1000 * 60 * 30, // 30 minutes
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
})

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,

  integrations: [],

  // Capture performance
  tracesSampleRate: 1.0,

  // Optional – track user sessions
  sendDefaultPii: true,
});

import { GoogleOAuthProvider } from '@react-oauth/google';

const container = document.getElementById("root");
const googleClientId = import.meta.env.VITE_GOOGLE_CLIENT_ID || 'your-google-client-id.apps.googleusercontent.com';

createRoot(container).render(
  <GoogleOAuthProvider clientId={googleClientId}>
    <QueryClientProvider client={queryClient}>
      <SocketProvider>
        <NotificationsProvider>
          <App />
        </NotificationsProvider>
      </SocketProvider>
    </QueryClientProvider>
  </GoogleOAuthProvider>,
)
